import React, { useState, useEffect } from "react";
import "./LearnersSchool.css";
import PapersPage from "../PapersPage";
import PDFViewerPage from "../PDFViewerPage";
import Videos from "../Videos";
import { useSelector } from "react-redux";
import { learnersSchoolData } from "../../dummyData/learnersSchoolData";


function LearnersSchool() {

  const [showContent, setShowContent] = useState(false);

  // 🌍 Language state from Redux
  const selectedLanguage = useSelector((state) => state.language.language);
  const [langData, setLangData] = useState(learnersSchoolData.english);

  // 🔁 Language switch effect
  useEffect(() => {
    switch (selectedLanguage.value) {
      case "sinhala":
        setLangData(learnersSchoolData.sinhala);
        break;
      case "tamil":
        setLangData(learnersSchoolData.tamil);
        break;
      case "english":
      default:
        setLangData(learnersSchoolData.english);
        break;
    }
  }, [selectedLanguage]);

  return (
    <div className="px-5 pt-5 learners-school">
      <h2 className="text-center mb-4 fw-bold pt-5">
        {langData.title.split(langData.drive)[0]}
        <span className="drive-text">{langData.drive}</span>
        {langData.title.split(langData.drive)[1]}
      </h2>

      <div
        className="accordion learners-accordion accordion-wrapper"
        id="learnersSchoolAccordion"
      >

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#videoLessons"
              aria-expanded="false"
              aria-controls="videoLessons"
              onClick={() => setShowContent(true)}
            >
              {langData.sections.videos}
            </button>
          </h2>

          <div
            id="videoLessons"
            className="accordion-collapse collapse"
            data-bs-parent="#learnersSchoolAccordion"
          >
            <div className="accordion-body">
              {showContent && (
                <div className="videos-wrapper">
                  <Videos />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ================= Past Papers ================= */}

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#pastPapers"

              aria-expanded="false"
              aria-controls="pastPapers"
              onClick={() => setShowContent(true)}

            >
              {langData.sections.papers}
            </button>
           
          </h2>

          <div
            id="pastPapers"
            className="accordion-collapse collapse"
            data-bs-parent="#learnersSchoolAccordion"
          >

            <div className="accordion-body">
              {showContent && (
                <div className="papers-section-wrapper">
                  <PapersPage />
                </div>
              )}
            </div>

          </div>
        </div>

        {/* ================= Driving Handbook ================= */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#drivingHandbook"

              aria-expanded="false"
              aria-controls="drivingHandbook"
              onClick={() => setShowContent(true)}
            >
              {langData.sections.handbook}
            </button>
           
          </h2>

          <div
            id="drivingHandbook"
            className="accordion-collapse collapse"
            data-bs-parent="#learnersSchoolAccordion"
          >

            <div className="accordion-body">
              {showContent && (
                <div className="pdfviewerpage-wrapper">
                  <PDFViewerPage />
                </div>
              )}
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default LearnersSchool;
